export const WARN_AGGRO_BETTING_PAYLOAD_DEFINITION = {
    definitionParts: []
};
